class Auth{
  constructor() {
    this.authenticated = false;
    this.userrole = '';
  }
  loginWithFireBase(user){
    this.authenticated = true
    this.userrole = user
  }
  login(userData,cb){

    if(userData.userName.toLocaleLowerCase() === 'admin'){
      this.authenticated = true;
      this.userrole = 'admin';
    }
    else if(userData.userName.toLocaleLowerCase() === 'officer'){
      this.authenticated = true;
      this.userrole = 'officer';
    }
    else if(userData.userName.toLocaleLowerCase() === 'surveyor'){
      this.authenticated = true;
      this.userrole = 'surveyor';
    }
    else{
      this.authenticated = false;
    }
    cb();
        
      
  }
  logout(cb){
    this.authenticated = false;
    this.adminstatus = false;
    this.userrole = '';
    localStorage.removeItem('token')
    cb();
  }
  isAuthenticated(){
    return this.authenticated;
  }
  isAdmin(){
    return this.adminstatus;
  }
  checkRole(){
    return 'admin';
  }
}

export default new Auth();
